import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textSearch'
})
export class TextSearchPipePipe implements PipeTransform {
  transform(items: any[], text?: any): any {
    //console.log(text)
    if(!text){
      return items;
    }
    return items.filter((item)=>{
      if(item.settingstype && typeof item.settingstype === 'string'){
        return item.settingstype.toLowerCase().indexOf(text.toLowerCase())> -1;
      }
      return false;
    })
  }
}
